import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  accounts: [],
  accountsListPage:[],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  custom_rate: {},
  dynamicFields: [],
  analytics: [],
  current_page: 1,
  per_page: PAGELENGTH,
}

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState: initialState,
  reducers: {
    setAccount: (state, { payload }) => {
      state.accounts = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setAccounts: (state, { payload }) => {
      state.accounts = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setAccountsListPage: (state, { payload }) => {
      state.accountsListPage = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setDynamicFields: (state, { payload }) => {
      state.dynamicFields = payload?.data||payload;
    },
    setCustomRate: (state, { payload }) => {
      state.custom_rate = payload?.data||payload;
    },
    clearCustomRate: (state) => {
    state.custom_rate = {};
    },
    setMoreAccounts: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
    },
    removeAccount: (state, { payload }) => {
      state.error = payload
    },
    clearAllAccount: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addAccount = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addAccount(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAccount(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateAccount = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateAccount(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAccount(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeAccount = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeAccount(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAccount(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchAccounts = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAccounts(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          // dispatch(setAccounts(result.data.data));
          return result?.data?.data;
        } else {
          dispatch(setAccounts(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setAccounts(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }else{
      !disableLoader && dispatch(setLoader(false))
    }
  } catch (error) {
    console.log("error", error)
    !disableLoader && dispatch(setLoader(false))
  }
}

export const fetchAccountsListPage = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAccountsListPage(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          // dispatch(setAccounts(result.data.data));
          return result?.data?.data;
        } else {
          dispatch(setAccountsListPage(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setAccountsListPage(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }else{
      !disableLoader && dispatch(setLoader(false))
    }
  } catch (error) {
    console.log("error", error)
    !disableLoader && dispatch(setLoader(false))
  }
}

export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "subclients/accounts")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleAccounts = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleAccounts(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
};

export const fetchSubClients = (subclient_id, params, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch &&  dispatch(setLoader(true))
  try {

    const result = await Api.fetchSubClients(subclient_id, params)
    if (result.status >= 200 && result.status < 300) {
      dispatch && dispatch(setDynamicFields(result.data));
      return result.data
    }
    else if (result?.status == 422) {
      dispatch && dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch && dispatch(setLoader(false))
}


export const fetchCustomRate = (page, query, disableLoader, asyncFlag) => async (dispatch) => {
  if (!disableLoader) dispatch(setLoader(true));

  try {
    const result = await Api.fetchCustomRate(page, query);

    if (result.status >= 200 && result.status < 300) {
      // ✅ always dispatch setCustomRate — even if record not found
      if (result?.data?.success === false) {
        dispatch(setCustomRate({ success: false, rate: null, duration: null }));
      } else {
        dispatch(setCustomRate(result.data));
      }
    } else if (result?.status === 422) {
      dispatch(setError(result.data));
      dispatch(setCustomRate({ success: false, rate: null, duration: null }));
    } else {
      // any other error → clear custom rate
      dispatch(setCustomRate({ success: false, rate: null, duration: null }));
    }
  } catch (error) {
    console.log("error", error);
    // ✅ API crash → also clear
    dispatch(setCustomRate({ success: false, rate: null, duration: null }));
  }

  if (!disableLoader) dispatch(setLoader(false));
};


export const { setAccount, setAccounts,setAccountsListPage, clearAllAccount, setLoader, setError, setMoreAccounts, setDynamicFields, setCustomRate, clearCustomRate } = accountsSlice.actions


export default accountsSlice.reducer
export const accountsSelector = state => state.accounts


